export default [
  {
    path: '/welfare',
    name: 'welfare',
    component: () => import('@/views/welfare/welfare'),
    meta: { title: '福利中心' }
  },
  {
    path: '/welfareInfo',
    name: 'welfareInfo',
    component: () => import('@/views/welfare/welfareInfo'),
    meta: { title: '奖励明细' }
  },
  {
    path: '/welfareRule',
    name: 'welfareRule',
    component: () => import('@/views/welfare/welfareRule'),
    meta: { title: '规则' }
  },
]



// WEBPACK FOOTER //
// ./src/router/config/welfare.js